import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="flex justify-between items-center bg-darkBlue p-3">
            <p className="opacity-75 text-xs text-white cursor-default">© 2026 Bruno Curi. All Rights Reserved.</p>
            <a href="/privacy-policy" className="text-cyan text-xs hover:text-white transition duration-300">{t("privacyPolicy")}</a>
        </footer>
    );
}